export default __webpack_public_path__ + "static/8-c4dfdab87d1e8675178fd8b7ce3544a6.svg";